import { LogChange } from "../types/logs/change.type";
import { formatDateTime } from "../utils/formatters";
import ChangesColumn from "../components/LogChangesTable/components/ChangesColumn";
import LogChangeActionLink from "../components/LogChangesTable/components/LogChangeActionLink";

interface TableTransformerOptions {
  basePath?: string;
}

const sanitizeBasePath = (basePath?: string) => {
  if (!basePath) return "";

  return basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
};

export class LogChangesTransformer {
  static tableTransformer({ basePath }: TableTransformerOptions = {}) {
    const sanitizedBasePath = sanitizeBasePath(basePath);

    return (logChanges: LogChange[]) => {
      return logChanges.map((log) => {
        const hasRequest = Boolean(log.request_id);
        const linkTo = hasRequest
          ? sanitizedBasePath
            ? `${sanitizedBasePath}/${log.request_id}`
            : log.request_id
          : undefined;

        return {
          ...log,
          created_at: formatDateTime(new Date(log.created_at)),
          full_name: log?.request?.performed_by?.full_name ? log.request.performed_by.full_name : 'Agente Tcard',
          description: (
            <p className="line-clamp-3 whitespace-normal">
              {log?.request?.operation_description ? log.request.operation_description : undefined}
            </p>
          ),
          item_name_translated: log.item_name_translated,
          changes: <ChangesColumn id={log.id} changes={log.object_changes_translated} />,
          changes_before: <ChangesColumn id={log.id} changes={log.object_changes_translated} col="changes_before" />,
          changes_after: <ChangesColumn id={log.id} changes={log.object_changes_translated} col="changes_after" />,
          actions: hasRequest && linkTo ? (
            <LogChangeActionLink
              requestId={log.request_id}
              linkTo={linkTo}
              actorHints={[
                log.request_performed_by_type,
                log.performed_by_type,
                log.request?.performed_by_type,
              ]}
              domainHints={[
                log.request_domain,
                log.domain,
                log.request?.domain,
              ]}
            />
          ) : null,
        };
      });
    };
  }
}
